import React, { useState, useEffect, useContext, useMemo } from "react";
import styled from "styled-components";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles, withStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Edit from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import UserService from "services/UserService";
import { getAccountContracts } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import useActionTable from "./useActionTable.js";
import { energyType, targetedenergyList } from "variables/lists/action";

import { compte } from "variables/patrimoine.js";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 4px solid rgba(231, 231, 231);
  border-top: 4px solid rgba(231, 231, 231);
  background-color: #f5f5f5;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;

const ExpandableComponent = ({ data }) => {
  let energy = data.details.energy;
  let parameters = "meters";

  return (
    <Container>
      <ExpandableContainer>
        {data.details.energy == "electricity" && (
          <>
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].powersubscriptionhph} :{" "}
              </ElementTitle>
              <ElementData>{data.details?.powersubscriptionhph}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].powersubscriptionhch} :{" "}
              </ElementTitle>
              <ElementData>{data.details?.powersubscriptionhch}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].powersubscriptionhpe} :{" "}
              </ElementTitle>
              <ElementData>{data.details?.powersubscriptionhpe}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].powersubscriptionhce} :{" "}
              </ElementTitle>
              <ElementData>{data.details?.powersubscriptionhce}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].powersubscriptionpointe} :{" "}
              </ElementTitle>
              <ElementData>{data.details?.powersubscriptionpointe}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].powersubscriptionbase} :{" "}
              </ElementTitle>
              <ElementData>{data.details?.powersubscriptionbase}</ElementData>
            </ExpandableElement>
          </>
        )}
      </ExpandableContainer>
    </Container>
  );
};

const RTMetersPowers = ({ selectedMeters, handleSelectedChange }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState, refreshTable } = useActionTable(selectedMeters);
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [selectedMeter, setSelectedMeter] = useState({});
  const [utilitiesData, setUtilitiesData] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const classes = useStyles();

  let energy = "electricity";
  let parameters = "meters";


  const columns = [
    {
      name: compte.energy[energy][parameters].meternumber,
      selector: (row) => row.meternumber,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].segment,
      selector: (row) =>  row.details.segment,
      sortable: true,
    },
  ];


  const contextMessage = {
    singular: "compteur",
    plural: "compteurs",
    message: "sélectionné(s)",
  };

  const rowSelectCritera = (row) => row.isSelected == true;
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        //noHeader={true}
        //title="Liste des contrats fournisseurs"
        noDataComponent="Aucun compteur(s) retrouvé dans le patrimoine"
        columns={columns}
        persistTableHead
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        selectableRows
        onSelectedRowsChange={handleSelectedChange}
        selectableRowSelected={rowSelectCritera}
        selectableRowsHighlight
        clearSelectedRows={toggleCleared}
        //contextActions={contextActions}
        contextMessage={contextMessage}
        pagination
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Compteurs par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les compteurs",
        }}
        {...gridState}
      />
    </>
  );
};

export default RTMetersPowers;
